import { filemanagerApi } from "@/config/http-filemanager";
import router from "@/router";
import { store } from "@/store";
import {
  AuthActions,
  AuthGetters,
  getAccountSessionToken,
} from "@/store/modules/auth";
import { getLocale } from "@/i18n";
import { notifyAssistantHttpError } from "@/services/assistant/AssistantErrorEventBus";

const TIMEOUT = 1000000;
let isRedirectingToLogin = false;

export const onRequestSuccess = (config: any) => {
  const token = getAccountSessionToken(
    store.getters[AuthGetters.GET_USER_IDENTITY]
  );
  const locale = getLocale();
  if (token) {
    if (!config.headers) {
      config.headers = {};
    }
    config.headers.Authorization = `Bearer ${token}`;
  }
  if (!config.headers) {
    config.headers = {};
  }
  config.headers["Accept-Language"] = locale;
  config.timeout = TIMEOUT;
  return config;
};

const redirectToLogin = async (onUnauthenticated: () => void) => {
  onUnauthenticated();
  await store.dispatch(AuthActions.LOGOUT);

  if (isRedirectingToLogin) {
    return;
  }

  isRedirectingToLogin = true;

  try {
    if (router.currentRoute.value.name !== "Auth") {
      window.location.replace("/login");
    }
  } finally {
    isRedirectingToLogin = false;
  }
};

export const setupFilemanagerInterceptors = (onUnauthenticated: () => void) => {
  const onResponseError = async (err: {
    status: any;
    response?: { status?: any };
  }) => {
    notifyAssistantHttpError(err, "FILEMANAGER_API");

    const status = err?.status || err?.response?.status;
    if (status === 401) {
      await redirectToLogin(onUnauthenticated);
    }
    return Promise.reject(err);
  };

  if (filemanagerApi.interceptors) {
    filemanagerApi.interceptors.request.use(onRequestSuccess);
    filemanagerApi.interceptors.response.use(
      (response) => response,
      (error) => onResponseError(error)
    );
  }
};
